// ./src/utils/helpers.js
import axios from 'axios'
import Swal from 'sweetalert2'

const baseURL = 'https://twitter-api-666.herokuapp.com/api'

export const apiHelper = axios.create({
  baseURL
})

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})